export const COMETCHAT_CONSTANTS = {
  APP_ID: '278538a17a6a73bf',
  REGION: 'IN',
  AUTH_KEY: '1b6c71f629c522df1142285087f6c5db188c8188',
  IS_STAGING: false,
} as const;

// NOTE: The commented-out COMETCHAT_CONSTANTS blocks below are necessary for
// testing and are intentionally left in place for testing purposes. Uncomment
// the relevant block (and comment out the live one above) to point the sample
// app at a different test app/environment.

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '2547167fe69871fd',
//   REGION: 'us',
//   AUTH_KEY: '5e1fc8edd290a2f194a6634178eb9db2895391ad',
//   IS_STAGING: true,
// } as const;

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '2709994865174007',
//   REGION: 'US',
//   AUTH_KEY: '6c530e515867fea837ca9cf3f5314a3814afc564',
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '253778b716dc6335',
//   REGION: 'US',
//   AUTH_KEY: 'eb66838530e31d1e5f68657faf9d4bc31b0cc354',
//   IS_STAGING: true,
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '281468e1dc60990c',
//   REGION: 'IN',
//   AUTH_KEY: '23bf9e9d4fad7deedf4325ed05ecc792450546dd',
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '28146524317a971d',
//   REGION: 'US',
//   AUTH_KEY: 'add21fd63e685bf5ca94247fff835978cdbabaeb',
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '281467653933f370',
//   REGION: 'EU',
//   AUTH_KEY: '76f9d99fb0f072992d22c305eb8c330c258fef86',
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '281468e1dc60990c',
//   REGION: 'IN',
//   AUTH_KEY: '23bf9e9d4fad7deedf4325ed05ecc792450546dd',
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: '26580020f03ff346',
//   REGION: 'IN',
//   AUTH_KEY: '4152b0366478871f0fa8d19a287dd6f5ed5f8eff',
// } as const;
